import moment from "moment";
import axios from "axios";
import { mapActions } from "vuex";
import { isJLPCSubDomain, getDomainDetails } from "@/router/general";
import { mapFields } from "vuex-map-fields";
import { subDomains } from "@/helpers/subdomains";
import numberCommaFormatter from "@pofnor/number-comma-formatter";

export default {
  data() {
    return {
      supportedCompanies: ["bennie", "broker", "frp", "higginbotham", "insuretrust", "mma", "rts"],
      exportingAssets: false,
      updatedDigitalAssetsDescription: [
        // using for handle description only in UI so BE shouldn't need any changes
        {
          oldValue: "IT & Cyber Security",
          newValue: "IT & Cybersecurity",
        },
      ],
      alphaSingleDataset: {
        // USED FOR ALPHA SINGLE PLAYER PROGRAM (CYBER BOOK VALUE)
        revenueBands: {
          "<1m": {
            minPremium: 0,
            maxPremium: 9985,
          },

          "1-5m": {
            minPremium: 9985,
            maxPremium: 11735,
          },

          "5-10m": {
            minPremium: 11735,
            maxPremium: 7234,
          },

          "10-25m": {
            minPremium: 7234,
            maxPremium: 12605,
          },

          "25-50m": {
            minPremium: 12605,
            maxPremium: 20187,
          },

          "50-100m": {
            minPremium: 20187,
            maxPremium: 17855,
          },

          "100-250m": {
            minPremium: 17855,
            maxPremium: 42775,
          },

          "250-500m": {
            minPremium: 42775,
            maxPremium: 59922,
          },

          "500-1b": {
            minPremium: 59922,
            maxPremium: 59546,
          },

          ">1b": {
            minPremium: 59546,
            maxPremium: 59546,
          },
        },
      },
      selectedCustomSortBy: null,
    };
  },

  computed: {
    ...mapFields("login", ["currentUser", "readOnlyView", "cwbInstanceDetails"]),

    appBarColor() {
      return this.cwbInstanceDetails && this.readOnlyView ? this.cwbInstanceDetails.appBarColor : "#fff";
    },
    subDomain() {
      const subdomain = getDomainDetails()?.subdomain;

      let item = null;

      for (const key in subDomains) {
        if (subdomain.includes(key)) {
          item = subDomains[key];
          break;
        }
      }

      const brokerage = {
        name: item?.organization_name,
        entity_id: item?.organization_id,
        website: item?.organization_url,
      };

      const subdomainDetails = {
        isPresent: !!item,
        brokerage,
      };


      return subdomainDetails;
    },
  },

  methods: {
    ...mapActions("digitalAssets", ["exportDigitalAsset"]),
    getSubDomainLogoInitial() {
      // using for sub domain like JLPC
      if (isJLPCSubDomain()) {
        return "jlpc-logo.png";
      }
      return null;
    },
    getAppLogoUrl() {
      const supportedCompanies = this.supportedCompanies;
      let domainDetails = getDomainDetails();

      let subdomain = domainDetails.subdomain;
      let logo = null;

      supportedCompanies.map((val) => {
        if (subdomain.includes(val)) {
          logo = val + "-logo.png";
        }
      });

      return logo;
    },
    checkValidDate(date) {
      return (
        moment(date, "MM/DD/YYYY", true).isValid() ||
        moment(date, "M/D/YYYY", true).isValid() ||
        moment(date, "MM/DD/YYYY", true).isValid() ||
        moment(date, "M/D/YY", true).isValid()
      );
    },
    formatDate(date, format = "MM/DD/YYYY") {
      if (!date) {
        return;
      }
      if (moment(date, ["YYYY-MM-DD", "MM-DD-YYYY", "ddd, DD MMM YYYY HH:mm:ss z"], true)) {
        return moment(date, ["YYYY-MM-DD", "MM-DD-YYYY", "ddd, DD MMM YYYY HH:mm:ss z"]).format(format);
      } else {
        if (date.split("T").length) {
          return moment(date.split("T")[0]).format(format);
        }
        return date;
      }
    },
    _normalizeItemId(itemId) {
      if (itemId == "IT & Cybersecurity") {
        return this.getMappingDigitalAssetDescription("IT & Cybersecurity").oldValue;
      }
      return itemId;
    },
    _hasClientDelegations(type) {
      return (
        this.clientDelegations?.[type]?.length ||
        type == "audit_answer"
      );
    },
    _findClientDelegationForUsageType(itemId, type) {
      const usage = this.usageOverview.find((e) => e.description.toLowerCase() == itemId?.toLowerCase());
      return this.clientDelegations[type].find((e) => e.item_id == usage?.digital_asset_usage_type);
    },
    _findClientDelegationForAuditAnswer(itemId, type, additionalData) {
      let clientDelegation = this.clientDelegations[type]?.find((e) => e.item_id == itemId);
      if (!clientDelegation && additionalData) {
        clientDelegation = this.clientDelegations.digital_asset?.find(
          (e) => e.item_id == additionalData.digital_asset_id
        );
        return { clientDelegation, foundFromAdditionalData: true };
      }
      return { clientDelegation, foundFromAdditionalData: false };
    },
    _findClientDelegation(itemId, type, additionalData) {
      if (type == "digital_asset_usage_type") {
        return {
          clientDelegation: this._findClientDelegationForUsageType(itemId, type),
          foundFromAdditionalData: false,
        };
      }
      if (type == "audit_answer") {
        return this._findClientDelegationForAuditAnswer(itemId, type, additionalData);
      }
      return {
        clientDelegation: this.clientDelegations[type]?.find((e) => e.item_id == itemId),
        foundFromAdditionalData: false,
      };
    },
    _setUserParentInitial(user, foundFromAdditionalData) {
      if (foundFromAdditionalData) {
        user.parentUserInitial = true;
      } else if (user?.parentUserInitial) {
        user.parentUserInitial = false;
      }
    },
    getDelegatedUserDetails(itemId, type, additionalData) {
      itemId = this._normalizeItemId(itemId);

      if (!this._hasClientDelegations(type)) {
        return false;
      }

      const { clientDelegation, foundFromAdditionalData } = this._findClientDelegation(itemId, type, additionalData);

      if (!clientDelegation) {
        return false;
      }

      const user = this.users.find((e) => e.entity_id == clientDelegation.user_id);
      if (user) {
        this._setUserParentInitial(user, foundFromAdditionalData);
      }
      return user;
    },
    _buildInitials(username) {
      if (!username) return "?";
      if (username.length > 1) return username[0][0] + username[1][0];
      return username[0][0];
    },
    getUserInitial(data) {
      let user = this.users.find((e) => e.entity_id === data.entity_id);
      let username = user?.name.trim().split(" ");
      return {
        initial: this._buildInitials(username),
        user: user,
      };
    },

    formatNumberWithComma(val) {
      if (val) {
        return numberCommaFormatter(val?.toString());
      }
      return "";
    },

    formatNumberWithCommaDecimal(val) {
      if (val) {
        return val.toLocaleString();
      }
      return "0.00";
    },

    formatNumberWithUsdIcon(val) {
      if (val) {
        const updatedVal = this.formatNumberWithComma(val.replaceAll("$", ""));
        if (updatedVal) {
          return "$" + updatedVal;
        }
        return updatedVal;
      }
    },

    formatStringToNumber(val) {
      if (!val) {
        return 0;
      }
      return Number.parseInt(val.replaceAll(/\D/g, "").replaceAll(",", ""), 10) || 0;
    },

    exportDigitalAssets() {
      this.exportingAssets = true;
      this.exportDigitalAsset(this.cwbInstanceDetails?.orgId)
        .then((response) => {
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onloadend = function () {
            const url = globalThis.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Digital Asset Inventory.pdf"); // or any other extension
            document.body.appendChild(link);
            link.click();
          };
        })
        .finally(() => (this.exportingAssets = false));
    },

    getMappingDigitalAssetDescription(value) {
      if (!value) return;
      let data = this.updatedDigitalAssetsDescription.find(
        (e) => e.oldValue?.toLowerCase() == value?.toLowerCase() || e.newValue?.toLowerCase() == value?.toLowerCase()
      );
      if (data) {
        return data;
      }
    },

    handleNumberValidation(e) {
      let charCode = e.which ? e.which : e.keyCode;

      // Allow arrow keys (left: 37, up: 38, right: 39, down: 40)
      if ([37, 38, 39, 40].includes(charCode)) {
        return;
      }

      // Allow numeric keypad digits
      if (charCode >= 96 && charCode <= 105) {
        return;
      }

      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) e.preventDefault();

      if ([189, 69].includes(charCode)) e.preventDefault();
    },

    async downloadFileStackFile(file) {
      const { handle, file_name, filename, name } = file;

      if (!handle) {
        throw new Error("File handle is a required argument.");
      }

      let finalFilename = file_name || filename || name || "download"; // Fallback to a generic name if filename and name are not provided

      try {
        this.isLoading = true;
        const response = await axios.get(`https://www.filestackapi.com/api/file/${handle}`, { responseType: "blob" });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(new Blob([response.data]));
        downloadLink.download = finalFilename;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();

        return response;
      } catch (error) {
        console.error(error);
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    viewFileStackFile(file) {
      if (!file.url) throw new Error("File url is a required argument.");
      globalThis.open(file.url, "_blank");
    },

    getFileExtension(fileName, mimeType) {
      // Try to get the extension from the mime type
      let extension = mimeType ? mimeType.split("/")[1] : null;

      // If the mime type doesn't provide a valid extension, extract it from the file name
      if (!extension) {
        extension = fileName.split(".").pop();
      }

      return extension;
    },

    dateFormatterForCustomSort(arg, ascending) {
      let date = moment(arg);
      if (!date.isValid()) {
        return ascending ? Infinity : -Infinity;
      }
      return Number.parseInt(date.format("x"), 10);
    },

    _shouldToggleDateSortOrder(config, indexValue) {
      return config?.type?.date?.includes(indexValue) && this.selectedCustomSortBy !== indexValue;
    },
    _extractDateValue(item, indexValue) {
      return this.dateFormatterForCustomSort(item[indexValue], true);
    },
    _extractObjectValue(item, index, sortByKey) {
      if (!item[index]?.length) {
        return null;
      }
      return item[index].sort((a, b) => (a[sortByKey] < b[sortByKey] ? -1 : 1))[0][sortByKey]?.trim();
    },
    _extractArrayValue(item, index) {
      if (!item[index]?.length) {
        return null;
      }
      return item[index].sort((a, b) => (a < b ? -1 : 1))[0]?.trim();
    },
    _extractDefaultValue(item, index) {
      const value = item[index];
      return typeof value === "string" ? value?.trim() : value;
    },
    _getSortValues(itemA, itemB, index, indexValue, config) {
      if (config?.type?.date?.includes(indexValue)) {
        return {
          valA: this._extractDateValue(itemA, indexValue),
          valB: this._extractDateValue(itemB, indexValue),
        };
      }

      const objectConfig = config?.type?.object?.find((e) => e.key === indexValue);
      if (objectConfig) {
        const sortByKey = objectConfig["sortBy"];
        return {
          valA: this._extractObjectValue(itemA, index, sortByKey),
          valB: this._extractObjectValue(itemB, index, sortByKey),
        };
      }

      if (config?.type?.array?.includes(indexValue)) {
        return {
          valA: this._extractArrayValue(itemA, index),
          valB: this._extractArrayValue(itemB, index),
        };
      }

      return {
        valA: this._extractDefaultValue(itemA, index),
        valB: this._extractDefaultValue(itemB, index),
      };
    },
    _isInvalidValue(val) {
      return val === null || val === "" || val === Infinity || val === -Infinity;
    },
    _compareAscending(valA, valB) {
      return valA < valB ? -1 : 1;
    },
    _compareDescending(valA, valB) {
      return valB < valA ? -1 : 1;
    },
    _compareValues(valA, valB, isDescending) {
      if (valA === valB) return 0;
      if (this._isInvalidValue(valA)) return 1;
      if (this._isInvalidValue(valB)) return -1;
      return isDescending ? this._compareDescending(valA, valB) : this._compareAscending(valA, valB);
    },
    getCustomSortedData(items, index, isDesc, config) {
      // config using for check keys such as date, array or object with sorting key
      const indexValue = index[0];

      if (this._shouldToggleDateSortOrder(config, indexValue)) {
        isDesc[0] = !isDesc[0]; // change default order for first click sort order should be newest first
      }

      items.sort((itemA, itemB) => {
        const { valA, valB } = this._getSortValues(itemA, itemB, index, indexValue, config);
        return this._compareValues(valA, valB, isDesc[0]);
      });

      this.selectedCustomSortBy = indexValue;
      return items;
    },
  },
};
